<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-07 17:27:53
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-03-17 14:02:38
 * @name: 琴行管理
 * @Description: 琴行管理
 * @FilePath: \preSaleNafterSaleBackstage\src\views\pianoCompanyManage\pianoCompanyManage.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <layout-normal>
    <div class="chooseStatus">
      <div
        class="choose-item"
        :class="{ choosed: item.value === status }"
        v-for="item of statusList"
        :key="item.value"
        @click="status = item.value"
      >
        {{ item.text }}
      </div>
    </div>
    <template v-if="status === 1">
      <company-list :pianoCompany="pianoCompany"></company-list>
    </template>
    <template v-if="status === 0">
      <company-list-waitapprove :pianoCompany="pianoCompany"></company-list-waitapprove>
    </template>
  </layout-normal>
</template>
<script>
import pianoCompany from "@/object/pianoCompany/pianoCompany.class.js";
import companyList from "@/components/pianoCompanyManage/company-list.vue";
import companyListWaitapprove from "@/components/pianoCompanyManage/company-list-waitapprove.vue";

export default {
  name: "pianoCompanyManage",
  components: {
    companyList,
    companyListWaitapprove,
  },
  data() {
    return {
      statusList: [
        {
          value: 1,
          text: "已通过琴行",
        },
        {
          value: 0,
          text: "待审批琴行",
        },
      ],
      status: 1,
      pianoCompany: new pianoCompany(),
    };
  },
  activated() {
    this.getSalers();
    this.getManagers();
    this.getCycles();
  },
  methods: {
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取销售数组
     */
    getSalers() {
      this.pianoCompany.getSalers();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 获取经理数组
     */
    getManagers() {
      this.pianoCompany.getManagers();
    },
    /**
     * @Auther: 罗耀祖
     * @LastEditors: 罗耀祖
     * @description: 还款周期可选列表
     */
    getCycles() {
      this.pianoCompany.getCycles();
    },
  },
};
</script>
<style lang="scss" scoped>
.chooseStatus {
  margin: 10px 0;
  width: 200px;
  border-radius: $Vars-border-radius-mini;
  border: 1px solid $Vars-border-second-color;
  overflow: hidden;
  @extend .extend-flex-start;
  .choose-item {
    flex: 1;
    height: 30px;
    background: white;
    @extend .extend-flex-center;
    @extend .extend-clickElement;
    font-size: $Vars-font-miniContent-size;
    color: black;
    &.choosed {
      background: $Vars-normal-color !important;
      color: white !important;
    }
  }
}
</style>